// Renders a printable filter-summary window with a clean table + total footer.
// Usage: printFilterSummary({ title, filters:[strings], columns:[{key,label,align?,format?}], rows, total, totalLabel })
export function printFilterSummary({ title, filters = [], columns = [], rows = [], total = 0, totalLabel = "Total" }) {
  const esc = (s) => String(s == null ? "" : s)
    .replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");
  const fmtRM = (v) => `RM ${Number(v || 0).toLocaleString("en-MY",{minimumFractionDigits:2,maximumFractionDigits:2})}`;
  const now = new Date().toLocaleString("en-GB",{ day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" });

  const head = columns.map(c => `<th style="text-align:${c.align==="right"?"right":"left"}">${esc(c.label)}</th>`).join("");
  const body = rows.map(r => {
    const tds = columns.map(c => {
      const raw = r[c.key];
      const v = c.format ? c.format(raw, r) : (raw == null ? "" : raw);
      return `<td style="text-align:${c.align==="right"?"right":"left"}">${esc(v)}</td>`;
    }).join("");
    return `<tr>${tds}</tr>`;
  }).join("");

  const totalColSpan = Math.max(1, columns.length - 1);
  const filtersHtml = filters.length ? `<div class="filters">${filters.map(f => `<span class="chip">${esc(f)}</span>`).join("")}</div>` : "";

  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${esc(title)}</title>
<style>
  * { box-sizing: border-box; }
  body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; color:#18181b; margin:32px; }
  .kicker { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size:10px; letter-spacing:0.3em; text-transform:uppercase; color:#71717a; margin-bottom:6px; }
  h1 { font-size:24px; margin:0 0 4px; letter-spacing:-0.02em; font-weight:900; }
  .meta { color:#71717a; font-size:12px; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
  .filters { margin:16px 0; display:flex; flex-wrap:wrap; gap:6px; }
  .chip { border:1px solid #e4e4e7; background:#fafafa; padding:3px 8px; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size:11px; color:#3f3f46; }
  table { width:100%; border-collapse:collapse; margin-top:16px; font-size:12px; }
  th, td { padding:8px 10px; border-bottom:1px solid #e4e4e7; vertical-align:top; }
  th { background:#f4f4f5; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size:10px; text-transform:uppercase; letter-spacing:0.05em; color:#52525b; }
  tfoot td { border-top:2px solid #a1a1aa; border-bottom:none; padding-top:12px; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-weight:900; font-size:13px; }
  .total-label { text-align:right; text-transform:uppercase; letter-spacing:0.2em; font-size:10px; color:#52525b; font-weight:400; }
  .total-value { text-align:right; }
  .foot-note { margin-top:24px; font-size:10px; color:#a1a1aa; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; text-transform:uppercase; letter-spacing:0.2em; }
  @media print { body { margin:16mm; } .no-print { display:none; } }
  .btn { position:fixed; top:16px; right:16px; background:#002FA7; color:#fff; border:none; padding:8px 14px; font-size:13px; cursor:pointer; }
</style></head>
<body>
  <button class="btn no-print" onclick="window.print()">Print / Save as PDF</button>
  <div class="kicker">Filter Summary</div>
  <h1>${esc(title)}</h1>
  <div class="meta">Generated ${esc(now)} · ${rows.length} row${rows.length===1?"":"s"}</div>
  ${filtersHtml}
  <table>
    <thead><tr>${head}</tr></thead>
    <tbody>${body || `<tr><td colspan="${columns.length}" style="text-align:center;color:#a1a1aa;padding:24px">No rows match these filters.</td></tr>`}</tbody>
    ${rows.length ? `<tfoot><tr><td class="total-label" colspan="${totalColSpan}">${esc(totalLabel)}</td><td class="total-value">${esc(fmtRM(total))}</td></tr></tfoot>` : ""}
  </table>
  <div class="foot-note">TomCargo · Filter summary export</div>
  <script>window.addEventListener("load", () => setTimeout(() => window.print(), 250));</script>
</body></html>`;

  const w = window.open("", "_blank", "width=900,height=700");
  if (!w) { alert("Please allow pop-ups to print the summary."); return; }
  w.document.open(); w.document.write(html); w.document.close();
}
